import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import get from 'lodash/get'

import COLORS from '@/checkout-instore-legacy/constants/Colors'
import IconSearch from '@/checkout-instore-legacy/components/Commons/Icons/Search'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

class SearchBar extends React.Component {
  constructor(props) {
    super(props)
    this.searchInput = null

    this.state = {
      term:
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.term,
    }
  }

  static getDerivedStateFromProps(props) {
    return {
      term: get(props.location, ['query', 'term']),
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname === '/search' &&
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.searchInput.focus()
    }
  }

  updateTerm = (term, skipDebounce) => {
    this.props.router.replace({
      pathname: '/search',
      query: {
        term,
        skipDebounce,
      },
    })
    this.setState({ term })
  }

  handleChange = (event) => {
    this.updateTerm(event.target.value)
  }

  handleFocus = () => {
    if (this.props.location.pathname !== '/search') {
      this.props.router.push({
        pathname: '/search',
        query: {
          term: this.state.term,
        },
      })
    }
  }

  handleClearClick = () => {
    this.updateTerm('')
    this.searchInput.value = ''
    this.searchInput.focus()
  }

  handleFormSubmit = (e) => {
    e.preventDefault()
    const { term } = this.state
    setTimeout(() => this.updateTerm(term, true))
  }

  getSearchInput() {
    return this.searchInput
  }

  focus() {
    this.searchInput.focus()
  }

  handleSearchClick = () => {
    this.searchInput.focus()
  }

  render() {
    const { term } = this.state
    const { mediaQuery, location, isNextLoading } = this.props
    const { pathname } = location
    const searchIconSize = mediaQuery({
      phone: 17,
      tablet: 22,
    })
    const cancelIconSize = mediaQuery({
      phone: 16,
      tablet: 20,
    })

    return (
      <form
        className="flex flex-auto items-center ba-l b--black-20 bg-base ph4-l"
        onSubmit={this.handleFormSubmit}
      >
        <div className="flex-none pl4-ns dn db-l">
          <IconSearch
            width={searchIconSize}
            height={searchIconSize}
            color="#CCCCCC"
            animate={false}
          />
        </div>
        <div className="flex-auto mh5-l pv2-ns">
          <input
            id="search-input"
            data-cy="search-input"
            autoFocus={pathname === '/search'}
            ref={(input) => {
              this.searchInput = input
            }}
            type="search"
            className="bn bg-transparent w-100 pv3 pv2-l f4 f5-l fw3 lh-copy-ns"
            placeholder={this.props.intl.formatMessage({ id: 'searchLabel' })}
            disabled={isNextLoading}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
          />
        </div>
        {term && !isNextLoading && (
          <div
            data-testid="cancel-btn"
            className="flex-none pa3 pointer f0"
            onClick={this.handleClearClick}
          >
            <Icon
              type="nc-cancel"
              size={cancelIconSize}
              color={COLORS.BG_MUTED_2}
            />
          </div>
        )}
      </form>
    )
  }
}

SearchBar.propTypes = {
  router: PropTypes.object,
  location: PropTypes.object,
  intl: intlShape.isRequired,
  mediaQuery: PropTypes.func,
  isNextLoading: PropTypes.bool,
}

export default withRouter(
  withMediaQuery(
    injectIntl(SearchBar, {
      forwardRef: true,
    }),
    {
      forwardRef: true,
    }
  )
)
